// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"9d7996bf","400":"5d27a7a2","608":"66c77050","895":"bd3754ac"}[chunkId] + ".chunk.js";
};